import { useAuth } from '@clerk/nextjs'
import Link from 'next/link'

import { dashboardPaths } from 'domains/website/website.paths'
import { useAnimation } from 'store/animations.state'

import Box from 'components/atomic/atoms/box'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'
import SharedHeaderUserDropdown from 'components/pages/@shared/header-user-dropdown'

const SessionLinks = () => {
  const { isSignedIn, isLoaded } = useAuth()
  const { animation } = useAnimation({ key: 'navbar-session' })

  if (!isLoaded) {
    return null
  }

  if (isSignedIn) {
    return (
      <Box
        flex={{ '@initial': 'column', '@sm': 'true' }}
        items={{ '@sm': 'center' }}
        css={{ spaceY: 4, animation, '@sm': { spaceY: 0, spaceX: 4 } }}
      >
        <Link href={dashboardPaths.dashboard}>
          <Button
            variant="reversed"
            size={{ '@initial': 'md', '@sm': 'sm' }}
            width={{ '@initial': 'full', '@sm': 'default' }}
          >
            Dashboard
          </Button>
        </Link>
        <Box css={{ display: 'none', '@sm': { display: 'block' } }}>
          <SharedHeaderUserDropdown />
        </Box>
      </Box>
    )
  }

  return (
    <Box
      flex={{ '@initial': 'column', '@sm': 'true' }}
      items={{ '@sm': 'center' }}
      css={{ spaceY: 4, animation, '@sm': { spaceY: 0, spaceX: 6 } }}
    >
      <Text as={Link} href={dashboardPaths.login} noWrap>
        <Button width="full" css={{ '@sm': { display: 'none' } }}>
          Sign In
        </Button>
        <Text
          colorHover="accent"
          size="sm"
          css={{ display: 'none', '@sm': { display: 'block' } }}
        >
          Sign In
        </Text>
      </Text>
      <Text as={Link} href={dashboardPaths.register} noWrap>
        <Button
          variant="gray"
          size={{ '@initial': 'md', '@sm': 'sm' }}
          width={{ '@initial': 'full', '@sm': 'default' }}
          css={{ color: '#A09FA6', '&:hover': { color: '$text1' } }}
        >
          Join Grafbase
        </Button>
      </Text>
    </Box>
  )
}

export default SessionLinks
